import { api } from '@api/api2';
import type { GetResidentAccountsPayload } from './types';

export const getResidentAccounts = (payload: GetResidentAccountsPayload) =>
  api.v4('get', 'personal-account/relation/get-available-personal-accounts', payload);
